import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, TagModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  userProfile: any = null;
  loading: boolean = true;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadUserProfile();
  }

  loadUserProfile(): void {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      const user = JSON.parse(userJson);
      const userId = user.id || user.sub; // Handle different token/user object structures
      
      if (userId) {
        this.apiService.getUser(userId).subscribe({
          next: (response) => {
            this.userProfile = response.data || response;
            this.loading = false;
          },
          error: (err) => {
            console.error('Failed to load profile', err);
            this.loading = false;
          }
        });
      }
    }
  }
}
